import _Runfest from './Runfest'

export const registerConfigDefault = _Runfest.registerConfigDefault
export const Runfest = _Runfest
export const ConfigRunfest = _Runfest
export const getConfigValue = _Runfest.selectors.getConfigValue
export const setConfigValue = _Runfest.actionCreators.setConfigValue
